// extracted by mini-css-extract-plugin
export default {"listContainer":"AppSideMenuOptions_listContainer__rkazg"};